module.exports = __webpack_public_path__ + "img/chapter_practice_active.a8cfa867.svg";